import { PlanItemRecord, PlanRecord, UserPlanEnrollmentRecord, UserPlanPeriodRecord, UserPlanQualifyingSessionRecord } from "@Shared/schemas/training-plans/trainingPlanSchemas";

export const TRAINING_PLANS_ONBOARDING_DIALOG = "training-plans-onboarding";

export enum TrainingPlansOnboardingStep {
  Intro,
  Profile,
  Frequency,
}

const TRAINING_PLANS_COMPLETED_SESSIONS_STORAGE_KEY = "training-plans-completed-sessions";

export interface ITrainingPlanProgressData {
  enrollment: UserPlanEnrollmentRecord;
  plan: PlanRecord;
  current_period: UserPlanPeriodRecord | null;
  suggested_items: PlanItemRecord[];
  qualifying_sessions: UserPlanQualifyingSessionRecord[];
  history: UserPlanPeriodRecord[];
}

export const isNoActiveEnrollmentError = (error: any) => {
  const message = typeof error === "string" ? error.toLowerCase() : `${error?.message || ""}`.toLowerCase();
  return error?.code === "not-found" || error?.code === "not_found" || message.includes("no active user plan enrollment found");
};

interface ITrainingPlanProgressStorageParams {
  accountId?: number | null;
  userId?: number | string | null;
}

const getTrainingPlansCompletedSessionsStorageKey = ({ accountId, userId }: ITrainingPlanProgressStorageParams) => {
  return `${TRAINING_PLANS_COMPLETED_SESSIONS_STORAGE_KEY}:${userId ?? "anonymous"}:${accountId ?? "unknown"}`;
};

export const getCompletedSessionsCount = (progressData: ITrainingPlanProgressData | null) => {
  return progressData?.current_period?.completed_sessions_count ?? 0;
};

export const getRequiredSessionsCount = (progressData: ITrainingPlanProgressData | null) => {
  return progressData?.current_period?.required_sessions_count ?? 0;
};

export const loadStoredCompletedSessionsCount = (params: ITrainingPlanProgressStorageParams) => {
  try {
    const rawValue = window.sessionStorage.getItem(getTrainingPlansCompletedSessionsStorageKey(params));

    if (rawValue === null) {
      return null;
    }

    const parsedValue = Number(rawValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  } catch (error) {
    console.warn("Could not load stored training plans completed sessions count", error);
    return null;
  }
};

export const storeCompletedSessionsCount = (params: ITrainingPlanProgressStorageParams, progressData: ITrainingPlanProgressData | null) => {
  try {
    const storageKey = getTrainingPlansCompletedSessionsStorageKey(params);

    if (!progressData?.enrollment?.is_active) {
      window.sessionStorage.removeItem(storageKey);
      return;
    }

    window.sessionStorage.setItem(storageKey, `${getCompletedSessionsCount(progressData)}`);
  } catch (error) {
    console.warn("Could not store training plans completed sessions count", error);
  }
};
